import { useQuery } from "@apollo/client";
import { useMemo } from "react";
import { findRewardsByIds } from "../graphql/queries/findRewardsByIds";

/** Returns id-keyed catalog rewards for the IDs present in an outcome config. */
export const useCurrentRewards = (config, outcomeData) => {
  const rewardIds = useMemo(() => {
    const configIds = Array.isArray(config?.rewards)
      ? config.rewards.map((r) => r.reward_id || r.rewardId).filter(Boolean)
      : [];
    const outcomeIds = Array.isArray(outcomeData?.reward_ids)
      ? outcomeData.reward_ids
      : [];
    return Array.from(new Set([...configIds, ...outcomeIds]));
  }, [config?.rewards, outcomeData?.reward_ids]);

  const { data, loading, error } = useQuery(findRewardsByIds, {
    variables: { ids: rewardIds },
    skip: rewardIds.length === 0,
    fetchPolicy: "network-only",
  });

  const rewardsById = useMemo(() => {
    const map = {};
    data?.findRewardsByIds?.forEach((reward) => {
      map[reward.id || reward.rewardId] = reward;
    });
    return map;
  }, [data]);

  return { rewardsById, loading, error };
};
